import styled from 'styled-components';
import settings from '~/assets/icons/settings.svg';
import { Popup } from '../Popup';

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	column-gap: 20px;

	img {
		pointer-events: none;
		user-select: none;
	}
`;

const StyledText = styled.label`
	color: rgba(255, 255, 255, 0.5);
	font-family: GT Walsheim Pro;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;

const StyledSettingIcon = styled.div`
	width: 16px;
	height: 16px;
	background-image: url(${settings});
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	opacity: 0.25;
`;

const StyledSettingsButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 40px;

	cursor: pointer;
`;

const StyledPopup = styled(Popup)`
	position: absolute;
	right: -65px;
	top: 50px;
`;

export {
	StyledContainer,
	StyledPopup,
	StyledSettingIcon,
	StyledSettingsButton,
	StyledText,
};
